<template>
  <div class="container text-center">
    <h3>(404) Page NotFound</h3>
  </div>
</template>

<script>
export default {};
</script>